<div class="mb-2">
  <hr class="recordDocumentType"/>
  <div class="mt-1 mb-1 resultHeader">
    <div class="iconStyling">
      <img src="../../../../assets/images/AMISOrange.png"
      alt="{{ 'abandonedMinesIcon' | translate | async }}" 
      attr.aria-label="{{ 'abandonedMinesIcon' | translate | async }}" aria-hidden="true">
    <span class="ml-2">
        <a (click)="openInSameTab()" (dblclick)="openInNewTab()">
          {{ 'abandoned.mine.record' | translate | async }}: {{ abandoned_mine_identifier }}
        </a>
    </span>
    </div>
    <div class="iconStyling recordIcon">
      <img src="../../../../assets/images/record-icon-yellow.png" 
        alt="{{ 'recordIcon' | translate | async }}" 
        attr.aria-label="{{ 'recordIcon' | translate | async }}" aria-hidden="true">
    </div>
  </div>

  <div class="resultsCardContainer">
    <div class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'mine.site.name' | translate | async }}</p>
      <p class="recordValue" innerHTML="{{ official_name | highlight : this.searchTerms }}">
        {{ official_name | highlight : this.searchTerms }}
      </p>
    </div>
    <div class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'township.area' | translate | async }}</p>
      <p class="recordValue" innerHTML="{{ mndm_township_area_name | highlight : this.searchTerms }}">
        {{ mndm_township_area_name | highlight : this.searchTerms }}
      </p>
    </div>
    <div *ngIf="primary_commodity" class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'commodity' | translate | async }}</p>
      <p class="recordValue" innerHTML="{{ primary_commodity | highlight : this.searchTerms }}">
        {{ primary_commodity | highlight : this.searchTerms }}
      </p>
    </div>
  </div>
</div>